import { toast } from "sonner";
import { validateUpload } from "./validateUpload";
import { getUploadToken } from "@/api/receiver/getUploadToken";
import { supabase } from "@/data/supabase";

interface UploadFileProps {
    newFiles: File[];
    files: File[];
    setFiles: (files: File[]) => void;
    uploadStatus: Record<string, number>; // Maps file names to upload status (0: pending, 30: validating, 60: uploading, -1: error)
    setUploadStatus: (status: Record<string, number>) => void;
    tempId?: string; // Temporary ID for the upload context
}
export function uploadFile({
    newFiles,
    files,
    setFiles,
    uploadStatus,
    setUploadStatus,
    tempId,
}: UploadFileProps) {
    for (const file of newFiles) {
        console.log("Validating File", file.name);
        const result = validateUpload({
            files,
            uploadedFile: file,
            tempId,
            newFilesLength: newFiles.length,
        });
        if (!result.valid && uploadStatus[file.name] !== -1) {
            toast.error(result.message);
            if (result.type !== "file_exists") {
                setUploadStatus((prev) => ({ ...prev, [file.name]: -1 }));
            } else {
                console.warn("File already exists:", file.name);
            }
            continue;
        } else if (!result.valid && uploadStatus[file.name] === -1) {
            // Remove the file from the list if it was previously marked as error
            setFiles((prev) => prev.filter((f) => f.name !== file.name));
            //remove the file from the upload status
            setUploadStatus((prev) => {
                const newStatus = { ...prev };
                delete newStatus[file.name];
                return newStatus;
            });
        }
        console.log("File passes validation");
        console.log("continue with file upload of file:", file.name);
        setUploadStatus((prev) => ({ ...prev, [file.name]: 0 }));
        uploadToSupabase({
            file,
            setFiles,
            uploadStatus,
            setUploadStatus,
            tempId,
        });
        // Add the file to the list of files
        setFiles((prev) => [...prev, file]);
    }
}

interface handleUploadFileProps {
    file: File;
    setFiles: (files: File[]) => void;
    uploadStatus: Record<string, number>; // Maps file names to upload status (0: pending, 30: validating, 60: uploading, -1: error)
    setUploadStatus: (status: Record<string, number>) => void;
    tempId?: string; // Temporary ID for the upload context
}
const uploadToSupabase = async ({
    file,
    setUploadStatus,
    tempId,
}: handleUploadFileProps) => {
    setUploadStatus((prev) => ({ ...prev, [file.name]: 60 }));
    console.log("Getting upload token for file", file.name);
    const uploadTokens = await getUploadToken({
        filesToUpload: [
            {
                claimDetailId: tempId!,
                fileName: file.name,
            },
        ],
    });
    setUploadStatus((prev) => ({ ...prev, [file.name]: 75 }));
    // Check if we got a valid upload token
    if (uploadTokens.data.length === 0 || !uploadTokens.data[0]) {
        setUploadStatus((prev) => ({ ...prev, [file.name]: -1 }));
        return;
    }

    console.log(`Uploading file ${file.name}`);
    //upload the file to the signed URL
    const { data, error } = await supabase.storage
        .from("claims")
        .uploadToSignedUrl(
            uploadTokens.data[0].path,
            uploadTokens.data[0].token,
            file,
        );
    setUploadStatus((prev) => ({ ...prev, [file.name]: 85 }));
    if (error) {
        console.error("File upload error:", error);
        toast.error(`Failed to upload file ${file.name}. Please try again.`);
        setUploadStatus((prev) => ({ ...prev, [file.name]: -1 }));
        return;
    }
    setUploadStatus((prev) => ({ ...prev, [file.name]: 100 }));
};
